import { Component, Output, EventEmitter } from '@angular/core';
import { Response } from '@angular/http';

import { AudienceService } from '../services/audience.service';
import { Audience } from '../model/audience';

@Component({
  selector: 'app-audienceheader',
  templateUrl: './audienceheader.component.html',
  styleUrls: ['./audienceheader.component.css']
})
export class AudienceheaderComponent {
  audienceName: string;
  @Output()
  newAudienceCreated = new EventEmitter<string>();

  constructor(private service: AudienceService) { }

  createNew(audienceName: string)  {
        this.newAudienceCreated.emit(audienceName);
        this.audienceName = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/audienceheader/audienceheader.component.ts